// removed by extract-text-webpack-plugin
module.exports = {"container":"Text__container___qJmAO"};


//////////////////
// WEBPACK FOOTER
// ./~/nucleus-widgets/lib/Text/Text.less
// module id = ./node_modules/nucleus-widgets/lib/Text/Text.less
// module chunks = 43